{
  "version": "1",
  "name": "Antiferromagnetic state with optimal control",
  "device": "MockDevice",
  "register": [
    { "name": "q0", "x": -7.5, "y": -3.75 },
    { "name": "q1", "x": 0, "y": -3.75 },
    { "name": "q2", "x": 7.5, "y": -3.75 },
    { "name": "q3", "x": -7.5, "y": 3.75 },
    { "name": "q4", "x": 0, "y": 3.75 },
    { "name": "q5", "x": 7.5, "y": 3.75 }
  ],
  "channels": { "ising": "rydberg_global" },
  "variables": {},
  "operations": [
    {
      "op": "pulse",
      "protocol": "min-delay",
      "channel": "ising",
      "amplitude": {
        "kind": "interpolated",
        "duration": 1200,
        "times": [0, 0.25, 0.5, 0.75, 1],
        "values": [1e-9, 11.405902685751728, 15.707947559985698, 15.707947559985698, 1e-9]
      },
      "detuning": {
        "kind": "interpolated",
        "duration": 1200,
        "times": [0, 0.25, 0.5, 0.75, 1],
        "values": [
          -31.41592653589793, -31.41592653589793, 8.854273919304688, 28.11696039322039,
          31.41592653589793
        ]
      },
      "phase": 0,
      "post_phase_shift": 0
    }
  ],
  "measurement": "ground-rydberg"
}
